<template>
  <div>
    <Breadcrumb :title="'Buyout'"></Breadcrumb>
    <BaseSearchBar :config="SearchBuyout" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="BuyoutEventToolBarConfig" @buttonClicked="BuyoutEventToolBarClick"></BaseToolBar>
    <BaseGrid
      :mode="'editform'"
      :excelExport="excelExport"
      :config="PartnerGridConfig"
      :data="PartnerGridData"
      @InfoItem="gotoBuyoutDetails"
      @AttachItem="BuyoutAttachment"
    ></BaseGrid>
    <BuyoutDocumentDropoffForm
      ref="buyoutDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedBuyout"
    ></BuyoutDocumentDropoffForm>
  </div>
</template>

<script>
// Breadcrumb implementation
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";

// Base Searchbar Implementation
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import funcUtil from "@/services/funcUtil.js";

// Base Toolbar Implementation
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import { PartnerGridConfig, ToolBarConfig } from "./BuyoutEventConfig.js";

import BaseBusinessEventRunningTotal from "@/models/BaseBusinessEventRunningTotal.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";

// Base Grid Implementation
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import BuyoutMixin from "@/mixins/Buyout.js";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import BuyoutDocumentDropoffForm from "@/components/forms/BuyoutDocumentDropoffForm.vue";
import { isNullOrUndefined } from "util";
import BaseModelBuyout from "@/models/BaseModelBuyout.js";
import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";
//var loader;

export default {
  name: "BuyoutEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility, BuyoutMixin],

  components: {
    Breadcrumb,
    BaseSearchBar,
    BaseToolBar,
    BaseGrid,
    BuyoutDocumentDropoffForm
  },

  data: function() {
    return {
      // Base Grid implementation
      PartnerGridConfig: PartnerGridConfig,
      buyoutPartnerGridId: PartnerGridConfig.grid.gridId,

      BaseModelPartner: BaseModelPartner,
      // BaseBusinessEventRunningTotal: BaseBusinessEventRunningTotal,
      BaseModelTransactionLog: BaseModelTransactionLog,
      BuyoutEventMasterData: [],

      // Base Toolbar with button implementation
      BuyoutEventToolBarConfig: ToolBarConfig,

      // Base Searchbar implementation
      SearchBuyout: {
        SearchData: ""
      },

      PartnerAPIData: [],
      // BusinessEventRunningTotalAPIData: [],
      BaseModelTransactionLogAPIData: [],

      PartnerGridData: [],
      // Document dropoff modal
      docModalConfig: {
        modalName: "Buyout Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedBuyout: {},

      BaseModelBuyout: BaseModelBuyout
    };
  },

  computed: {
    ...mapGetters("getModule", ["withFilter", "getAllItemFilter"])
  },

  mounted() {
    const self = this;
    // Tool bar grid setting
    //self._loadGridSettings(self.buyoutPartnerGridId);

    const grid = $("#buyoutPartnerGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateBuyoutEventMasterData);

    //self.getPartnerData();
    self.getBaseGridData();
  },

  methods: {
    ...mapActions("getModule", ["AddCollection"]),
    ...mapActions("postModule", ["UpdateAllItems", "CreateAllItems","deleteAllItem"]),

    async getBaseGridData() {
      await this.getPartnerData();
      this._loadGridSettings(this.buyoutPartnerGridId);
    },
    gotoBuyoutDetails: function(e) {
      const gview = $("#buyoutPartnerGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      this.AddCollection({
        key: "BuyoutTerminationDate",
        value: dataItem.LeaveDate
      });
      this.$router.push("/event/buyout/" + dataItem.Id);
      console.log('Data Item: ', dataItem);
    },

    markBoughtOut: function() {
      const self = this;
      const grid = $("#buyoutPartnerGrid").data("kendoGrid");
      var localPartnerData = [];
      var isPendingRecordExist=false;
    var selectedrows = grid.select();
     console.log("TotalselectedBuyoutrows:",selectedrows.length);
      if (selectedrows.length > 0) {
        
         var lstBuyouts = self.withFilter(
            self.BaseModelBuyout.list
          );

          var partnerLists = self.withFilter(
              self.BaseModelPartner.list
            );

        selectedrows.each(function(index,row) {
        console.log("Currentselectedtrow:",index);
        //const grdDataItem = grid.dataItem(this);
         const grdDataItem = grid.dataItem(row);
          // console.log(grdDataItem);

          // Check all partner's in details are approved. To mark boughout --Start
          // let filterBuyout = {
          //   filter: "PartnerId eq " + grdDataItem.Id
          // };
          // var lstBuyout = self.withFilter(
          //   self.BaseModelBuyout.list,
          //   filterBuyout
          // );

          let chkAllApproved = lstBuyouts.filter(obj => {
            return obj.PartnerId == grdDataItem.Id && obj.WorkflowStatus == "Pending";
          });
          // Check all partner's in details are approved. To mark boughout --End

          if (!isNullOrUndefined(chkAllApproved) && chkAllApproved.length > 0) {
            isPendingRecordExist = true;
            self._AlertPopup(
              "Partner cannot be marked as boughtout! All the partner's detailed items must be approved.",
              "info"
            );
          } else {
            
            var result = partnerLists.filter(x => x.Id == grdDataItem.Id);
          
            if (!isNullOrUndefined(result) && result.length > 0) {
              localPartnerData.push(result[0]);
            }
          }
        });
      } else {
        this._AlertPopup("Please select atleast one Partner.", "info");
      }


      if (localPartnerData.length > 0 && !isPendingRecordExist) {
      // localPartnerData =  localPartnerData.map(x=> x.BoughtOut = "Yes");
       localPartnerData.forEach(partner => {partner.BoughtOut="Yes"});

        var updateobject = {
          Partner: {
            config: self.BaseModelPartner,
            updateData: localPartnerData
          }
        };

        this._ConfirmationPopup(
          "This will buyout the selected partner(s). Are you sure?",
          "Confirm"
        ).then(response => {
          if (response.value) {
            //let loader = this.$loading.show();
            self._APICrudPopup("APICrudpopup");

            this.UpdateAllItems(updateobject)
              .then(res => {
                self.refreshGrid();
                //loader.hide();
                self._AlertPopup(
                  "Selected partners marked as bought out Successfully!",
                  "success"
                );
              })
              .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
              })
              .finally(() => {
                //loader.hide();
              });
          }
        });
      }
    },

    async startBuyout() {
      const self = this;
      const grid = $("#buyoutPartnerGrid").data("kendoGrid");
      var localGridData = [];
      let localPartnerData = [];
      let buyoutSaveData = [];
      let differenceBuyData = [];

      if (grid.select().length > 0) {
        grid.select().each(function(selectIndex) {
          const grdDataItem = grid.dataItem(this);
          localGridData.push(grdDataItem);
        });
        console.log(localGridData);
        if (localGridData.length > 0) {
          let userresponse = await this._ConfirmationPopup(
            'Partners with partner status as "Former Employee" and  non empty Termination Date are eligible for buyout.',
            "Confirm"
          );
          if (userresponse.value) {
            localGridData = _.filter(localGridData, function(o) {
              return (
                o.PartnerStatus == "Former Employee" &&
                !isNullOrUndefined(o.LeaveDate) &&
                o.PartnerName != "Treasury Units" //&&
                //o.StartBuyout != "Completed"
              );
            });
            // loader = self.$loading.show();
            self._APICrudPopup("APICrudpopup");

            // if (localGridData.length > 0) {
              console.log('Local Grid Data: ', localGridData);
              localGridData.forEach(partner => {
                let AffiliatedPartnerquery = {
                  filter: "PartnerId eq " + partner.Id
                };
                let AffiliatedPartnerList = this.withFilter(
                  BaseModelPartnerAffiliation.list,
                  AffiliatedPartnerquery
                );
                console.log("AffiliatedPartnerList", AffiliatedPartnerList);

                // concat partner id of affiliate and current partner
                let partnerID = [];
                partnerID.push({ PartnerId: partner.Id });
                AffiliatedPartnerList.forEach(element => {
                  partnerID.push({ PartnerId: element.AffiliatedPartnerId });
                });

                let filterBuyout = {
                  filter: "PartnerId eq " + partner.Id
                };

                let BuyoutDataOld = self.withFilter(
                  self.BaseModelBuyout.list,
                  filterBuyout
                );

                //Prepare Buyout data
                let buyoutData = self.startBuyoutProcess(
                  partnerID,
                  partner.LeaveDate
                );
                buyoutSaveData = []
                buyoutSaveData = buyoutSaveData.concat(buyoutData);
                console.log('Buyout Before Filter: ', buyoutSaveData);
                
                //buyoutSaveData = BuyoutDataOld.filter(item1 => buyoutSaveData.some(item2 => item1.ProgramId != item2.ProgramId))
                let uniqueResultTwo = [];
                uniqueResultTwo = buyoutSaveData.filter(function(obj) {
                    return !BuyoutDataOld.some(function(obj2) {
                       return obj.ProgramId == obj2.ProgramId &&
                               obj.UnitClass == obj2.UnitClass &&
                               obj.UnitType == obj2.UnitType &&
                               obj.Unit == obj2.Unit &&
                               obj.VestedUnit == obj2.VestedUnit &&
                               obj.VestingType == obj2.VestingType
                    });
                });
                differenceBuyData = [];
                differenceBuyData = BuyoutDataOld.filter(function(obj) {
                    return !buyoutSaveData.some(function(obj2) {
                        return obj.ProgramId == obj2.ProgramId &&
                               obj.UnitClass == obj2.UnitClass &&
                               obj.UnitType == obj2.UnitType &&
                               obj.Unit == obj2.Unit &&
                               obj.VestedUnit == obj2.VestedUnit &&
                               obj.VestingType == obj2.VestingType
                    });
                });

                console.log("differenceBuyData",differenceBuyData);

                buyoutSaveData = []
                buyoutSaveData = uniqueResultTwo;
                console.log('Buyout Save Data: ', buyoutSaveData);
                partnerID.forEach(allpartners => {
                  let filterQuery = {
                    filter: "Id eq " + allpartners.PartnerId
                  };
                  let result = self.withFilter(
                    self.BaseModelPartner.list,
                    filterQuery
                  );

                  if (result.length > 0) {
                    result[0].StartBuyout = "Completed";
                    result[0].PartnerStatus = "Former Employee";
                    result[0].LeaveDate = partner.LeaveDate;
                    localPartnerData.push(result[0]);
                  }
                });
              });
              try {

                var deletedobject = {
                  Buyout: {
                    config: BaseModelBuyout,
                    deleteData: differenceBuyData,
                    processInBatches:true
                  }
                };
                let deleteObjectResponse = null;
                 deleteObjectResponse = await self.deleteAllItem(deletedobject);
                console.log('deleteObjectResponse',deleteObjectResponse);

                var createdobject = {
                  Buyout: {
                    config: BaseModelBuyout,
                    createData: buyoutSaveData,
                    processInBatches: true
                  }
                };
                let createResponse = null;
                createResponse = await self.CreateAllItems(createdobject);
                console.log('createResponse',createResponse);
                if (createResponse) {
                  var updateobject = {
                    Partner: {
                      config: BaseModelPartner,
                      updateData: localPartnerData,
                      processInBatches: true
                    }
                  };
                  let updateResponse = await self.UpdateAllItems(updateobject);
                  //refresh the grid data only after the update gets completed
                  self.refreshGrid();
                  //loader.hide();
                  self._AlertPopup(
                    "Selected eligible partner(s) buyout started successfully!",
                    "success"
                  );
                }
              } catch (error) {
                this._AlertPopup("Some Error Occurred!", "info");
                console.log(error);
              }
            // } else {
            //   self.refreshGrid();
            //   //loader.hide();
            //   self._AlertPopup(
            //     "Selected partners are already bought out or none of selected Partners eligible for buyout ",
            //     "info"
            //   );
            // }
          }
        }
      } else {
        this._AlertPopup("Please select atleast one Partner.", "info");
      }
    },

    startRetire: function() {
      const self = this;
      const grid = $("#buyoutPartnerGrid").data("kendoGrid");
      var localGridData = [];
      let localPartnerData = [];

      if (grid.select().length > 0) {
        grid.select().each(function(selectIndex) {
          const grdDataItem = grid.dataItem(this);
          localGridData.push(grdDataItem);
        });
        console.log(localGridData);
        if (localGridData.length > 0) {
          this._ConfirmationPopup(
            'Partners with partner status as "Retired Employee" and  non empty Termination Date are eligible for buyout.',
            "Confirm"
          ).then(response => {
            if (response.value) {
              localGridData = _.filter(localGridData, function(o) {
                return (
                  o.PartnerStatus == "Retired Employee" &&
                  !isNullOrUndefined(o.LeaveDate) &&
                  o.StartRetire != "Completed"
                );
              });
              //loader = self.$loading.show();
              self._APICrudPopup("APICrudpopup");

              if (localGridData.length > 0) {
                localGridData.forEach(partner => {
                  let filterQuery = {
                    filter: "Id eq " + partner.Id
                  };
                  var result = self.withFilter(
                    self.BaseModelPartner.list,
                    filterQuery
                  );

                  if (result.length > 0) {
                    result[0].StartRetire = "Completed";
                    localPartnerData.push(result[0]);
                  }
                });
                var updateobject = {
                  Partner: {
                    config: BaseModelPartner,
                    updateData: localPartnerData,
                    processInBatches: true
                  }
                };
                self
                  .UpdateAllItems(updateobject)
                  .then(res => {
                    //refresh the grid data only after the update gets completed
                    self.refreshGrid();
                    //loader.hide();
                    self._AlertPopup(
                      "Selected eligible partner(s) Retirement started successfully!",
                      "success"
                    );
                  })
                  .catch(error => {
                    self._AlertPopup("Some Error Occurred!", "info");
                  })
                  .finally(() => {
                    //loader.hide();
                  });
              } else {
                self.refreshGrid();
                //loader.hide();
                self._AlertPopup(
                  "Selected partners are already retired or none of selected Partners are eligible for Retirement ",
                  "info"
                );
              }
            }
          });
        }
      } else {
        this._AlertPopup("Please select atleast one Partner.", "info");
      }
    },

    UpdateBuyoutEventMasterData: function(fromFilter, filterMasterData) {
      const self = this;
      if (fromFilter == true) {
        self.BuyoutEventMasterData = filterMasterData;
      } else {
        self.BuyoutEventMasterData = $("#buyoutPartnerGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
      self.gridColumnNonEditable();
    },

    // Grid search
    filterGrid: function() {
      const self = this;
      const currentMasterdata = self.BuyoutEventMasterData;

      let filteredData = self._filterGrid(
        self.BuyoutEventMasterData,
        self.SearchBuyout.SearchData
      );

      $("#buyoutPartnerGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      self.UpdateBuyoutEventMasterData(true, currentMasterdata);
    },

    // Toolbar Submit Forfeiture butt, Generate Document
    BuyoutEventToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id === "btnGenerateLetter") {
        // self.AddPartner();
      }
      if (e.id == "btnStartBuyout") {
        self.startBuyout();
      }
      if (e.id == "btnStartRetire") {
        self.startRetire();
      }
      if (e.id === "btnBoughtOut") {
        self.markBoughtOut();
      }
      if (e.id == "btnRefresh") {
        self.refreshGrid();
      }
      self._baseToolBarEvents(self.buyoutPartnerGridId, ...arguments);
    },

    refreshGrid: function() {
      this.getPartnerData();
    },

    async getPartnerData() {
      const self = this;

      let bundleObject = {
        Partner: {
          config: self.BaseModelPartner
        },
        // BusinessEventRunningTotal: {
        //   config: BaseBusinessEventRunningTotal
        // }
        BaseModelTransactionLog: {
          config: BaseModelTransactionLog
        }
      };

      let response = this.getAllItemFilter(bundleObject);

      self.PartnerAPIData = response.Partner;
      // self.BusinessEventRunningTotalAPIData =
      //   response.BusinessEventRunningTotal;
      self.BaseModelTransactionLogAPIData = response.BaseModelTransactionLog;

      let formerPartner = await _.filter(self.PartnerAPIData, function(obj) {
        return (
          obj.BoughtOut != "Yes" &&
          (obj.PartnerStatus == "Former Employee" ||
            obj.PartnerStatus == "Retired Employee") &&
          obj.FullName != "Treasury Units"
        );
      });
      // console.log("partnerData", formerPartner)

      let uniquePartnerId = _.uniq(
        _.map(self.BaseModelTransactionLogAPIData, "PartnerId")
      );
      // console.log("uniquepartnerData", uniquePartnerId)

      self.PartnerGridData = [];
      for (let i = 0; i < uniquePartnerId.length; i++) {
        let result = _.filter(formerPartner, function(obj) {
          return (
            obj.Id.toString()
              .trim()
              .toLowerCase() ==
            uniquePartnerId[i]
              .toString()
              .trim()
              .toLowerCase()
          );
        })[0];

        if (result) {
          let gridData = {};
          gridData.Id = result.Id;
          gridData.PartnerID = result.PartnerID;
          gridData.PartnerName = result.FullName;
          gridData.PartnerStatus = result.PartnerStatus;
          gridData.LeaveDate = result.LeaveDate;
          gridData.StartBuyout = result.StartBuyout;
          gridData.StartRetire = result.StartRetire;

          self.PartnerGridData.push(gridData);
        }
      }
      console.log('Partner Grid Data: ', self.PartnerGridData);
    },
    BuyoutAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#buyoutPartnerGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedBuyout = { ...dataItem };

      (this.selectedBuyout.PartnerTitle = dataItem.PartnerName),
        (this.selectedBuyout.PartnerId = dataItem.Id);
      this.selectedBuyout.ProgramTitle = null;
      this.selectedBuyout.ProgramId = null;
      this.selectedBuyout.TransactionID = null;
      this.selectedBuyout.BusinessEvent = "Buyout";

      this.filterCondition.filter = `BusinessEvent eq 'Buyout' and PartnerId eq ${dataItem.Id}`;

      this.$refs.buyoutDocument.$refs.buyoutDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    gridColumnNonEditable: function() {
      var grid = $("#buyoutPartnerGrid").data("kendoGrid");

      if (grid.tbody.find("tr").length) {
        grid.tbody.find("tr").each(function() {
          // console.log($(this));

          let dataItem = grid.dataItem(this);
          if (dataItem.PartnerStatus == "Retired Employee") {
            if ($(this).find("td").length) {
              // console.log($(this));

              $(this)
                .find("td")
                .each(function(index) {
                  if (index == 1) {
                    $(this).addClass("disableRowCells");
                  }
                });
            }
          }
        });
      }
    }
  }
};
</script>
